export default "__VITE_ASSET__BJ2xjum7__"